<template>
  <v-dialog persistent v-model="showDialog" width="500" eager>
    <v-card>
      <v-card-title class="justify-space-between">
        Ready to create a EventConnect link?
        <v-btn fab text small @click="$emit('closeDialog')"
          ><v-icon class="text-right">close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <p>
          Unlock EventConnect with Evolve and take connecting to another level
          for your event attendees.
        </p>
        <v-sheet outlined color="secondary" class="rounded-lg mt-5">
          <div>
            <v-card
              class="text-center rounded-t-lg"
              color="secondary"
              dark
              flat
            >
              <v-card-title
                class="justify-center text-h4 align-end font-weight-bold"
                >$29.95<span class="text-body-2">/month</span></v-card-title
              >
              <v-card-subtitle class="font-weight-400"
                >+ $3.00/month/additional team member</v-card-subtitle
              >
            </v-card>
            <v-card class="rounded-b-lg" tile>
              <v-card-text>
                <p class="text-subtitle-1 mb-0">
                  You get everything in Grow plus all these...
                </p>
                <v-list dense class="pa-0">
                  <v-list-item
                    v-for="item in items"
                    :key="item.id"
                    class="px-0"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary"> mdi-check </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      {{ item.text }}
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">
                        mdi-check
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Business Card Prize Draws
                    </v-list-item-title>
                  </v-list-item> -->
                  <!-- <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">
                        mdi-check
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Promotion for all your events
                    </v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-card-text>
            </v-card>
          </div>
        </v-sheet>
        <v-btn color="primary" depressed block class="text-body-1 mt-15"
          >Upgrade & Continue</v-btn
        >
        <!-- <v-btn
          color="primary"
          depressed
          block
          text
          class="text-body-1 mt-4"
          absolute
          @click="$emit('closeDialog')"
          >Cancel</v-btn
        > -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showDialog: { type: Boolean },
  },
  data() {
    return {
      items: [
        { id: "1", text: "EventConnect" },
        { id: "2", text: "Business Card Prize Draws" },
        { id: "3", text: "Promotion for all your events" },
      ],
    };
  },
};
</script>

<style></style>
